<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Pre-1920s: Mountain Men, Good Samaritans and Life-Savers</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The 1920s and 1930s: The Golden Age of Volunteer Search and Rescue</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The 1940s and 1950s: World War II and the Birth of National SAR</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The 1960s and 1970s: Outdoor Recreation and Growing Demand for SAR Services</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. 1980s to the Present: SAR Professionalization and Government Involvement</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?02dcdb3d